import { useSyncExternalStore } from 'react'

const subscribe = () => () => undefined

// False during server rendering and hydration, true once running on the client.
export function useIsHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  )
}
